import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDecimal'
})
export class CustomDecimalPipe implements PipeTransform {
  transform(value: number, digits: string = '1.0-0'): string {
    if (isNaN(value)) return '';
    if (value === null || value === undefined) return '';

    // Exponential表記を避けるため、固定小数点表記に変換
    return value.toLocaleString('ja-JP', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
}
